export default __webpack_public_path__ + "static/media/user-img-1.5e75409b.webp";